import React, { useState, useEffect } from 'react'
import { ACTION } from 'consts/index'
import { useDispatch } from 'react-redux'
import { getFileName, removeAccents } from 'utils'
import timezones from 'timezones-list'
//antd
import {
  Input,
  Button,
  Row,
  notification,
  Modal,
  Form,
  Select,
  Upload,
  InputNumber,
  Spin,
  DatePicker
} from 'antd'

//apis
import { addCountry, getFullCountries, updateCountry } from 'apis/country'
import { InboxOutlined, LoadingOutlined, NodeExpandOutlined, PlusOutlined } from '@ant-design/icons'
import { uploadFile } from 'apis/upload'

export default function CountryForm({ reloadData, children, infoCountry, countries = [] }) {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const [imageCountry, setImageCountry] = useState('')
  const [imagesIntro, setImagesIntro] = useState([])
  const [imagesParty, setImagesParty] = useState([])
  const [loadingImageIntro, setLoadingImageIntro] = useState(false)
  const [loadingImagesParty, setLoadingImagesParty] = useState(false)
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)

  const [initialImagesParty, setInitialImagesParty] = useState(infoCountry?.image_party || [])
  useEffect(() => {
    if (!visible) {
      form.resetFields();
      setImagesParty([...initialImagesParty]); // Khôi phục ảnh ban đầu khi modal đóng
    } else {
      if (infoCountry) {
        setImageCountry(infoCountry.image_url || '');
        setImagesParty(infoCountry.image_party || []);
        setInitialImagesParty(infoCountry.image_party || []); // Lưu ảnh ban đầu khi modal mở
        form.setFieldsValue({ ...infoCountry });
      }
    }
  }, [visible]);

  const _addOrUpdateCountry = async () => {
    try {
      await form.validateFields()
      const formData = form.getFieldsValue()
      dispatch({ type: ACTION.LOADING, data: true })
      const dataCountry = countries.find((item) => item.code === formData.country_code)

      const body = {
        ...dataCountry,
        ...formData,
        image_url: imageCountry,
        image_intro: imagesIntro,
        image_party: imagesParty,
        // subdomain: removeAccents(formData.name, true).toLowerCase(),
        
      }

      let res
      if (infoCountry) res = await updateCountry(infoCountry.country_id, body)
      else res = await addCountry(body)
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          reloadData()
          notification.success({
            message: `${infoCountry ? 'Cập nhật' : 'Tạo'} quốc gia thành công`,
          })
          setVisible(false)
        } else
          notification.error({
            message:
              res.data.message ||
              `${infoCountry ? 'Cập nhật' : 'Tạo'} quốc gia thất bại, vui lòng thử lại!`,
          })
      } else
        notification.error({
          message:
            res.data.message ||
            `${infoCountry ? 'Cập nhật' : 'Tạo'} quốc gia thất bại, vui lòng thử lại!`,
        })
      dispatch({ type: ACTION.LOADING, data: false })
    } catch (error) {
      console.log(error)
      dispatch({ type: ACTION.LOADING, data: false })
    }
  }

  const _uploadImageCountry = async (file) => {
    try {
      setLoading(true)
      const url = await uploadFile(file)
      setLoading(false)
      if (url) setImageCountry(url || '')
    } catch (error) {
      setLoading(false)
    }
  }

  const handleDeleteImageIntro = async (url) => {
    try {
      if (url) {
        const imagesIntroNew = [...imagesIntro]
        const imageIndex = imagesIntroNew.findIndex((img) => img === url)
        if (imageIndex !== -1) imagesIntroNew.splice(imageIndex, 1)
        setImagesIntro([...imagesIntroNew])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDeleteImagePartys = async (url) => {
    try {
      if (url) {
        const imagesPartyNew = [...imagesParty]
        const imageIndex = imagesPartyNew.findIndex((img) => img === url)
        if (imageIndex !== -1) imagesPartyNew.splice(imageIndex, 1)
        setImagesParty([...imagesPartyNew])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const _uploadImageIntro = async (file) => {
    try {
      setLoadingImageIntro(true)
      const url = await uploadFile(file)
      setLoadingImageIntro(false)
      if (url) {
        imagesIntro.push(url)
        setImagesIntro([...imagesIntro])
      }
    } catch (error) {
      setLoadingImageIntro(false)
      console.log(error)
    }
  }

  const _uploadImageParty = async (file) => {
    try {
      setLoadingImagesParty(true)
      const url = await uploadFile(file)
      setLoadingImagesParty(false)
      if (url) {
        imagesParty.push(url)
        setImagesParty([...imagesParty])
      }
    } catch (error) {
      setLoadingImagesParty(false)
      console.log(error)
    }
  }

  const changeDate = async (date) =>{
  }

  //reset
  useEffect(() => {
    if (!visible) {
      form.resetFields()
    } else {
      if (infoCountry) {
        setImageCountry(infoCountry.image_url || '')
        setImagesIntro(infoCountry.image_intro || [])
        form.setFieldsValue({ ...infoCountry })
      }
    }
  }, [visible])

  return (
    <>
      <div onClick={() => setVisible(true)}>{children}</div>
      <Modal
        style={{ top: 20 }}
        title={infoCountry ? 'Cập nhật quốc gia' : 'Thêm quốc gia'}
        centered
        width={850}
        footer={null}
        visible={visible}
        onCancel={() => setVisible(false)}
      >
        <Form form={form} layout="vertical">
          <div>
            <div>Hình ảnh</div>
            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              data={_uploadImageCountry}
            >
              {imageCountry ? (
                <img
                  src={imageCountry}
                  alt="avatar"
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              ) : (
                <div>
                  {loading ? <LoadingOutlined /> : <PlusOutlined />}
                  <div style={{ marginTop: 8 }}>Tải lên</div>
                </div>
              )}
            </Upload>
          </div>
          <Row justify="space-between" align="middle">
            <Form.Item
              name="country_code"
              label="Quốc gia"
              rules={[{ required: true, message: 'Vui lòng nhập tên quốc gia!' }]}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
                style={{ width: 350 }}
                size="large"
                placeholder="Chọn quốc gia"
              >
                {countries.map((country, index) => (
                  <Select.Option value={country.code} key={index}>
                    {country.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="subdomain"
              label="Tên subdomain"
              rules={[{ required: true, message: 'Vui lòng nhập tên subdomain!' }]}
            >
              <Input
                allowClear
                size="large"
                style={{ width: 350 }}
                placeholder="Nhập tên subdomain"
              />
            </Form.Item>
            <Form.Item
              name="currency"
              label="Tiền tệ"
              rules={[{ required: true, message: 'Vui lòng nhập tiền tệ!' }]}
            >
              <Input allowClear size="large" style={{ width: 350 }} placeholder="Nhập tiền tệ" />
            </Form.Item>

            <Form.Item
              name="rate_currency"
              label="Tỉ lệ đổi giá"
              rules={[{ required: true, message: 'Vui lòng nhập tỉ lệ đổi giá!' }]}
            >
              <InputNumber
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                size="large"
                style={{ width: 350 }}
                placeholder="Nhập tỉ lệ đổi giá"
              />
            </Form.Item>
            <Form.Item
              label="Timezone"
              name="timezone"
              rules={[{ required: true, message: 'Vui lòng chọn timezone!' }]}
            >
              <Select size="large" showSearch placeholder="Choose timezone" style={{ width: 350 }}>
                {timezones.map((timezone, index) => (
                  <Select.Option key={index} value={timezone.tzCode}>
                    {timezone.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item initialValue="" label="Ưu tiên hiển thị" name="priority">
              <Input
                allowClear
                size="large"
                style={{ width: '100%' }}
                placeholder="Nhập số ưu tiên"
              />
            </Form.Item>
            <Form.Item
              name="require_amount_order"
              label="Đơn hàng tối thiểu"
              rules={[{ required: true, message: 'Vui lòng nhập đơn hàng tối thiểu!' }]}
            >
              <InputNumber
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                size="large"
                style={{ width: 350 }}
                placeholder="Nhập đơn hàng tối thiểu"
              />
            </Form.Item>
            <Form.Item
              name="require_amount_deposit"
              label="Deposit for one guest"
              rules={[{ required: true, message: 'Please input deposit amount for one people!' }]}
            >
              <InputNumber
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                size="large"
                style={{ width: 350 }}
                placeholder="Please input deposit amount for one people"
              />
            </Form.Item>
            <Form.Item
              name="require_amount_baby"
              label="Deposit for one Baby"
              rules={[{ required: true, message: 'Please input deposit amount for one baby!' }]}
            >
              <InputNumber
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                min={0}
                size="large"
                style={{ width: 350 }}
                placeholder="Please input deposit amount for one baby"
              />
            </Form.Item>
            <Form.Item
              name="client_paypal"
              label="Paypal ID"
              rules={[{rquired: true, message: 'Please input Paypal client here'}]}
            >
                <Input
                // formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                // parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                // min={0}
                allowClear
                size="large"
                style={{width: 350}}
                placeholder="Please input Paypal client here"
                />
              </Form.Item>
          </Row>
          <div>
            <div>Hình ảnh giới thiệu</div>
            <Upload.Dragger
              fileList={imagesIntro.map((image, index) => ({
                uid: index,
                name: getFileName(image),
                status: 'done',
                url: image,
                thumbUrl: image,
              }))}
              listType="picture"
              onChange={(info) => {
                info.file.status = 'done'
              }}
              accept="image/*"
              name="file"
              data={(file) => _uploadImageIntro(file)}
              onRemove={(file) => handleDeleteImageIntro(file?.url)}
            >
              <p className="ant-upload-drag-icon">
                {loadingImageIntro ? <Spin /> : <InboxOutlined />}
              </p>
              <p className="ant-upload-text">Nhấp hoặc kéo ảnh vào khu vực này để tải lên</p>
            </Upload.Dragger>
          </div>

          <Form.Item
            name="link_popup"
            label="Link liên kết khi bấm vào hình ảnh Popup"
            //rules={[{ required: true, message: 'Please enter the link popup!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: 650 }}
              placeholder="Nhập link cho popup"
            />
          </Form.Item>

          <Form.Item
            name="description_footer"
            label="Mô tả Footer"
            rules={[{ required: true, message: 'Vui lòng nhập mô tả footer!' }]}
          >
            <Input.TextArea
              allowClear
              size="large"
              style={{ width: 650, height: 200 }}
              placeholder="Nhập mô tả footer"
            />
          </Form.Item>

          <Form.Item
            name="link_instagram"
            label="Link instagram"
            rules={[{ required: true, message: 'Vui lòng nhập link instagram!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: 650 }}
              placeholder="Nhập link instagram"
            />
          </Form.Item>

          <Form.Item
            name="link_facebook"
            label="Link facebook"
            rules={[{ required: true, message: 'Vui lòng nhập link facebook!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: 650 }}
              placeholder="Nhập link facebook"
            />
          </Form.Item>

          <Form.Item
            name="link_whatsApp"
            label="Link WhatsApp"
            rules={[{required: true, message: 'Vui long nhap link WhatsApp'}]}
          >
            <Input
            allowClear
            size="large"
            style={{width: 650}}
            placeholder="Nhập link WhatsApp"
            />
          </Form.Item>

          <Form.Item
            name="link_line"
            label="Link Line"
            rules={[{required: false, message: 'Vui long nhap link Line'}]}
          >
            <Input
            allowClear
            size="large"
            style={{width: 650}}
            placeholder="Nhập link Line"
            />
          </Form.Item>

          <Form.Item
            name="link_zalo"
            label="Link Zalo"
            rules={[{required: false, message: 'Vui lòng nhập link Zalo'}]}
          >
            <Input
              allowClear
              size="large"
              style={{width: 650}}
              placeholder="Nhập link Zalo"
            />
          </Form.Item>

          <Form.Item
            name="link_tiktot"
            label="Link Tiktot"
            rules={[{required: true, message: 'Vui long nhập link Tiktot'}]}
          >
            <Input
              allowClear
              size="large"
              style={{width: 650}}
              placeholder="Nhập link Tiktot"
            />
          </Form.Item>

          {/* delivery */}
          <Form.Item
            name="name_email"
            label="Name email delivery"
            rules={[{ required: true, message: 'Vui lòng nhập tên người gửi email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập name email delivery"
            />
          </Form.Item>

          <Form.Item
            name="email_login"
            label="Tên đăng nhập email delivery"
            rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập tên đăng nhập email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password email delivery"
            rules={[{ required: true, message: 'Vui lòng nhập password email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập password email"
            />
          </Form.Item>

          <Form.Item
            name="reply_to"
            label="Reply to email delivery"
            rules={[{ required: true, message: 'Vui lòng nhập reply to email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập reply to email"
            />
          </Form.Item>

          {/* carrer */}

          <Form.Item
            name="name_email_carrer"
            label="Name email carrer"
            rules={[{ required: true, message: 'Vui lòng nhập tên người gửi email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập name email delivery"
            />
          </Form.Item>

          <Form.Item
            name="email_login_carrer"
            label="Tên đăng nhập email carrer"
            rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập tên đăng nhập email"
            />
          </Form.Item>

          <Form.Item
            name="password_carrer"
            label="Password email carrer"
            rules={[{ required: true, message: 'Vui lòng nhập password email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập password email"
            />
          </Form.Item>

          <Form.Item
            name="reply_to_carrer"
            label="Reply to email carrer"
            rules={[{ required: true, message: 'Vui lòng nhập reply to email!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập reply to email"
            />
          </Form.Item>

          <Form.Item
            name="email_login_invitation"
            label="Tên đăng nhập email invitation"
            rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập invitation!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập tên đăng nhập invitation"
            />
          </Form.Item>

          <Form.Item
            name="password_invitation"
            label="Password email invitation"
            rules={[{ required: true, message: 'Vui lòng nhập password email invitation!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập password email"
            />
          </Form.Item>

          <Form.Item
            name="reply_to_invitation"
            label="Reply to email invitation"
            rules={[{ required: true, message: 'Vui lòng nhập email reply invitation!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập email reply invitation"
            />
          </Form.Item>
         
          <Form.Item
            name="date_invitation_line1"
            label="Date invitation (Line1)"
            rules={[{ required: true, message: 'Vui lòng nhập thứ!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập thứ"
            />
          </Form.Item>
          <Form.Item
            name="date_invitation_line2"
            label="Date invitation (Line2)"
            rules={[{ required: true, message: 'Vui lòng nhập ngày!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập ngày"
            />
          </Form.Item>
          <Form.Item
            name="time_invitation_line1"
            label="Time invitation (Line1)"
            rules={[{ required: true, message: 'Vui lòng nhập time invitation!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập time invitation"
            />
          </Form.Item>
          <Form.Item
            name="time_invitation_line2"
            label="Time invitation (Line2)"
            rules={[{ required: true, message: 'Vui lòng nhập time invitation!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập time invitation"
            />
          </Form.Item>
          <Form.Item
            name="location_invitation_line1"
            label="location invitation (Line1)"
            rules={[{ required: true, message: 'Vui lòng nhập location invitation!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập location invitation"
            />
          </Form.Item>
          <Form.Item
            name="location_invitation_line2"
            label="location invitation (Line2)"
            rules={[{ required: true, message: 'Vui lòng nhập location invitation!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập location invitation"
            />
          </Form.Item>
          <Form.Item
            name="location_invitation_link"
            label="location invitation (Link)"
            rules={[{ required: true, message: 'Vui lòng nhập link google map!' }]}
          >
            <Input
              allowClear
              size="large"
              style={{ width: '100%' }}
              placeholder="Nhập link googlemap"
            />
          </Form.Item>
          <Form.Item
                  rules={[{ required: true, message: 'Vui lòng nhập ngày!' }]}
                  label="Ngày sự kiện"
                  name="date_event"
              >
              <Input
                allowClear
                size="large"
                style={{ width: '100%' }}
                placeholder="YYYY-MM-DD"
              />
          </Form.Item>
        </Form>
        <br />
        <div>
            <div>Hình ảnh tiệc</div>
            <Upload.Dragger
              fileList={imagesParty.map((image, index) => ({
                uid: index,
                name: getFileName(image),
                status: 'done',
                url: image,
                thumbUrl: image,
              }))}
              listType="picture"
              onChange={(info) => {
                info.file.status = 'done'
              }}
              accept="image/*"
              name="file"
              multiple="true"
              data={(file) => _uploadImageParty(file)}
              onRemove={(file) => handleDeleteImagePartys(file?.url)}
            >
              <p className="ant-upload-drag-icon">
                {loadingImagesParty ? <Spin /> : <InboxOutlined />}
              </p>
              <p className="ant-upload-text">Nhấp hoặc kéo ảnh vào khu vực này để tải lên</p>
            </Upload.Dragger>
          </div>
        <Row justify="end">
          <Button size="large" type="primary" onClick={_addOrUpdateCountry}>
            {infoCountry ? 'Cập nhật' : 'Thêm'}
          </Button>
        </Row>
      </Modal>
    </>
  )
}
